import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type BusinessHoursStore } from '../../store/BusinessHoursStore.ts'

type IActionEditContentProps = {
  store: BusinessHoursStore
}

export const BusinessHoursEditContent = observer(({ store }: IActionEditContentProps) => {
  const { isBusinessHoursActive, businessHoursLink } = store

  if (isBusinessHoursActive) {
    return (
      <Alert
        item={{
          type: 'infoLight',
          desc: 'Need to change your business hours?',
        }}
        actions={[
          {
            type: 'primary',
            variant: 'link',
            text: 'Setup business hours',
            link: businessHoursLink,
          },
        ]}
      />
    )
  } else {
    return (
      <Alert
        item={{
          type: 'warning',
          desc: 'Business hours are currently disabled. To use them, please turn them on',
        }}
        actions={[
          {
            type: 'primary',
            variant: 'link',
            text: 'Setup business hours',
            link: businessHoursLink,
          },
        ]}
      />
    )
  }
})
